import { lazy, Suspense } from 'react';

const DevTranslationEditor = import.meta.env.DEV
  ? lazy(() =>
      import('./DevTranslationEditor').then((module) => ({
        default: module.DevTranslationEditor,
      }))
    )
  : null;

export function DevTranslationEditorHost() {
  if (!import.meta.env.DEV || !DevTranslationEditor) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <DevTranslationEditor />
    </Suspense>
  );
}
